const states = {
  wip: {
    value: "wip",
    label: "1 - Application in progress",
    dashboardLabel: "1 - WIP",
    parent: "new",
    color: "inProgress",
    chartColor: "#eaaf39",
    order: 1,
  },
  applied: {
    value: "applied",
    label: "2 - Applied - to review",
    dashboardLabel: "2 - Applied",
    parent: "new",
    color: "inProgress",
    chartColor: "#eaaf39",
    order: 2,
  },
  inPipeline: {
    value: "dealPreparation",
    label: "3 - In Pipeline",
    dashboardLabel: "3 - In Pipeline",
    parent: "new",
    color: "inProgress",
    chartColor: "#eaaf39",
    order: 3,
  },
  rejected: {
    value: "rejected",
    label: "4 - Rejected",
    dashboardLabel: "4 - Rejected",
    parent: "closed",
    color: "denied",
    chartColor: "#c0c0c0",
    order: 4,
  },
  published: {
    value: "published",
    label: "5 - Ready for investment",
    dashboardLabel: "5 -Investment ready",
    parent: "published",
    color: "done",
    chartColor: "#009EF7",
    order: 5,
  },
  funded: {
    value: "funded",
    label: "6 - Fully/partially funded",
    dashboardLabel: "6 - Funded",
    parent: "published",
    color: "done",
    chartColor: "#009EF7",
    order: 6,
  },
  archived: {
    value: "archived",
    label: "Archived",
    parent: "closed",
    color: "denied",
    chartColor: "#c0c0c0",
    order: 7,
  },
};

module.exports = states;
